import { type AuthHeader, authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

export type MyRank = {
  rank: number;
  potentialRedeemablePoints: string;
  freePointsToNextRank?: string;
};

type GetMyLeaderboardRankResponse = {
  myRank: MyRank;
};

export type GetMyLeaderboardRankResponseProps = {
  leaderboardCycleId?: string;
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string, headers: AuthHeader) => Promise<GetMyLeaderboardRankResponse>;
};

export const createDefaultGetMyLeaderboardRankFetcher = () => {
  return (url: string, headers: AuthHeader) => romanApi.get<GetMyLeaderboardRankResponse>(url, undefined, { headers });
};

export const useGetMyLeaderboardRank = ({
  leaderboardCycleId,
  swrOptions,
  fetcher,
}: GetMyLeaderboardRankResponseProps) => {
  const leaderboardFetcher = fetcher || createDefaultGetMyLeaderboardRankFetcher();

  const swrQuery = useSWR(
    authHeader.get() && leaderboardCycleId ? `/leaderboard/my-rank/${leaderboardCycleId}` : null,
    (url: string) => leaderboardFetcher(url, authHeader.getOrThrow()),
    swrOptions,
  );

  return {
    myRank: swrQuery.data?.myRank ?? null,
    ...swrQuery,
  };
};
